import { FC, useState, useEffect } from "react";
import { Switch, Route, Redirect, withRouter } from "react-router-dom";
import Login from "./modules/Account/AccountLogin/index";
import ForgotPassword from "./modules/Account/AccountActions/forgot-password/index";
import ChangePassword from "./modules/Account/AccountActions/forgot-password/change-password";
import env from "./config/env";
import http from "./services/http";
import { getActiveSessionKey } from "./utils/SsoSession";
import LogoutPage from "./modules/Logout";
import ClientStore from "../src/modules/Admin/ClientManagement/store";

import { MessageResultState } from "./types/general-types";
import WithoutLayout from "./components/Layout/WithoutLayout";
import AppShell from "./redesign/shell/AppShell";
import RedesignPortalSelection from "./redesign/views/PortalSelection";
import RedesignClientManagement from "./redesign/views/ClientManagement";
import RedesignLoginAsUser from "./redesign/views/LoginAsUser";
import RedesignProfile from "./redesign/views/Profile";

interface IState {
  token: string | null;
  isAuthorized: undefined | boolean;
}

const { API_BASE_URL } = env;

const Routers: FC = (props: any) => {
  const { location } = props;
  http.defaults.baseURL = API_BASE_URL;
  const [state] = useState<IState>({
    token: getActiveSessionKey(),
    isAuthorized: getActiveSessionKey() ? true : false,
  });

  useEffect(() => {
    if (state.isAuthorized === false) {
      if (
        location.pathname !== "/" &&
        location.pathname !== "/login" &&
        location.pathname !== "/forgot-password" &&
        location.pathname !== "/change-password"
      ) {
        window.location.href = "login";
      }
    } else {
      const queryParams = new URLSearchParams(window.location.search);
      const clientId = queryParams.get("clientId");
      const returnUrl = queryParams.get("returnUrl");
      if (clientId) {
        new ClientStore().getById(clientId).then((res) => {
          if (res.state === MessageResultState.SUCCESS) {
            window.location.href =
              res.result.redirectUri +
              "?sessionKey=" +
              state.token +
              (returnUrl ? "&returnUrl=" + returnUrl : "");
          }
        });
      } else {
        if (location.pathname === "/" || location.pathname === "/login") {
          window.location.href = "portal-selection";
        }
      }
    }
  }, [state]);

  return (
    <>
      {/* Dışarıdaki <button> sarmalayıcısını kaldırın */}
      {/* <div>
        <LanguageSelection />
      </div> */}
      <Switch>
        <Route
          path={"/portal-selection"}
          component={() => <AppShell view={RedesignPortalSelection} />}
        />
        <Route
          exact
          path="/client-page"
          component={() => <AppShell view={RedesignClientManagement} />}
        />
        {/* Yeni tasarımda ayrı bir Harici Kullanıcılar ekranı yok: yönetim işlemleri
            Kullanıcı Olarak Giriş Yap sayfasının Harici Kullanıcılar sekmesine taşındı.
            Route, dışarıda kalmış bağlantılar için yönlendirme olarak duruyor. */}
        <Route
          exact
          path="/external-user-page"
          component={() => <Redirect to="/login-as-user" />}
        />
        <Route
          exact
          path="/login-as-user"
          component={() => <AppShell view={RedesignLoginAsUser} />}
        />
        <Route
          exact
          path="/"
          component={() => <WithoutLayout component={Login} />}
        />
        <Route
          exact
          path="/login"
          component={() => <WithoutLayout component={Login} />}
        />
        <Route
          exact
          path="/forgot-password"
          component={() => <WithoutLayout component={ForgotPassword} />}
        />
        <Route
          exact
          path="/change-password"
          component={() => <WithoutLayout component={ChangePassword} />}
        />

        <Route
          exact
          path="/logout"
          component={() => <WithoutLayout component={LogoutPage} />}
        />
        <Route
          exact
          path="/my-profile"
          component={() => <AppShell view={RedesignProfile} />}
        />
      </Switch>
    </>
  );
};

export default withRouter(Routers);
